import type { ReactNode } from 'react';
import { CAPABILITY_SCOPES, type CapabilityId } from '@/auth/scopes';
import { useSession } from '@/store/session';

/**
 * Reusable per-module consent gate (§4 incremental consent). A module's data is
 * never read until the admin clicks "Grant & load" here — the click is the point
 * of consent for that module's scopes. Renders children only once consented.
 */
export function ModuleGate({
  cap,
  children,
}: {
  cap: CapabilityId;
  children: ReactNode;
}) {
  const consented = useSession((s) => s.hasConsent(cap));
  const grant = useSession((s) => s.grantConsent);
  const desc = CAPABILITY_SCOPES[cap];

  if (consented) return <>{children}</>;

  return (
    <div className="gate">
      {desc.scopes.length > 0 ? (
        <code className="panel__scopes">{desc.scopes.join('  ·  ')}</code>
      ) : (
        <p className="small muted">No additional permission required — derived from data already read.</p>
      )}
      <div className="gate__cta">
        <button className="btn btn--primary" onClick={() => grant(cap)}>
          Grant &amp; load
        </button>
      </div>
    </div>
  );
}
